import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./StudentDashboard.css";

function StudentDashboard() {
  const [student, setStudent] = useState(null);
  const [installments, setInstallments] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const token = localStorage.getItem("studentToken");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const res = await fetch("http://localhost:5000/api/student-auth/me", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const data = await res.json();
      if (res.ok) {
        setStudent(data.student);
        setInstallments(data.installments || []);
      } else {
        localStorage.removeItem("studentToken");
        navigate("/login");
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("studentToken");
    localStorage.removeItem("studentData");
    navigate("/login");
  };

  if (loading) return <div className="student-dashboard-loading">Loading Dashboard...</div>;
  if (!student) return null;

  const profileImageUrl = student.profileImage 
    ? `http://localhost:5000${student.profileImage}`
    : "/default-avatar.png";

  return (
    <div className="student-dashboard">
      <div className="student-sidebar">
        <div className="student-sidebar-profile">
          <img 
            src={profileImageUrl} 
            alt="Profile" 
            className="student-profile-img"
            onError={(e) => { e.target.src = "https://via.placeholder.com/100" }} 
          />
          <h3>{student.name}</h3>
          <p>{student.course}</p>
        </div>
        
        <ul className="student-sidebar-menu">
          <li className="active">Profile Overview</li>
          <li onClick={handleLogout} className="logout-btn">Logout</li>
        </ul>
      </div>

      <div className="student-content">
        <div className="student-header">
          <h2>Welcome back, {student.name.split(' ')[0]}!</h2>
          <div className="branch-badge">
            🏢 {student.branchId?.branchName || student.branch}
          </div>
        </div>

        <div className="student-stats-grid">
          <div className="student-stat-card">
            <h4>Total Fee</h4>
            <h2>₹{student.totalFee?.toLocaleString('en-IN') || 0}</h2>
          </div>
          <div className="student-stat-card">
            <h4>Paid Fee</h4>
            <h2 style={{ color: '#10b981' }}>₹{student.paidFee?.toLocaleString('en-IN') || 0}</h2>
          </div>
          <div className="student-stat-card">
            <h4>Pending Fee</h4>
            <h2 style={{ color: '#ef4444' }}>₹{student.pendingFee?.toLocaleString('en-IN') || 0}</h2>
          </div>
          <div className="student-stat-card">
            <h4>Fee Status</h4>
            <h2 style={{ color: student.feeStatus === 'Paid' ? '#10b981' : student.feeStatus === 'Partially Paid' ? '#f59e0b' : '#ef4444' }}>
              {student.feeStatus || 'Pending'}
            </h2>
          </div>
        </div>

        <div className="student-details-card">
            <h3>Personal Information</h3>
            <div className="details-grid">
                <div>
                    <label>Email ID</label>
                    <p>{student.email}</p>
                </div>
                <div>
                    <label>Phone Number</label>
                    <p>{student.phone || 'N/A'}</p>
                </div>
                <div>
                    <label>Guardian Phone</label>
                    <p>{student.guardianPhone || 'N/A'}</p>
                </div>
                <div>
                    <label>Date of Birth</label>
                    <p>{student.dob ? new Date(student.dob).toLocaleDateString() : 'N/A'}</p>
                </div>
            </div>
        </div>

        <div className="student-details-card mt-4">
            <h3>Installments Plan</h3>
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Amount</th>
                            <th>Due Date</th>
                            <th>Paid Amount</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {installments.length > 0 ? installments.map((inst, index) => (
                            <tr key={inst._id}>
                                <td>{inst.installmentNumber}</td>
                                <td>₹{inst.amount.toLocaleString('en-IN')}</td>
                                <td>{new Date(inst.dueDate).toLocaleDateString()}</td>
                                <td>₹{inst.paidAmount.toLocaleString('en-IN')}</td>
                                <td>
                                    <span className={`status-badge ${inst.status.toLowerCase().replace(' ', '-')}`}>
                                        {inst.status}
                                    </span>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan="5" className="text-center text-muted">No installments found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>

      </div>
    </div>
  );
}

export default StudentDashboard;
